var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useState, Children, isValidElement, cloneElement, } from "react";
export const ButtonGroupV2 = ({ children, className = "", variant = "secondary", size = "md", defaultActiveIndex = 0, onChange, fullWidth = false, }) => {
    const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);
    const childrenCount = Children.count(children);
    // kept async, but only used internally
    const handleButtonClick = (index, value) => __awaiter(void 0, void 0, void 0, function* () {
        setActiveIndex(index);
        yield (onChange === null || onChange === void 0 ? void 0 : onChange(index, value));
    });
    const getGroupPosition = (index) => {
        if (childrenCount === 1)
            return "single";
        if (index === 0)
            return "first";
        if (index === childrenCount - 1)
            return "last";
        return "middle";
    };
    // ─── renderButton ───────────────────────────────────────────────────────
    // Add an explicit return type, and disable the promise-function-async rule
    // because this function itself must remain sync.
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const renderButton = (childNode, index) => {
        var _a, _b, _c;
        if (!isValidElement(childNode))
            return childNode;
        const position = getGroupPosition(index);
        const isActive = index === activeIndex;
        const handleClick = (e) => {
            var _a, _b;
            (_b = (_a = childNode.props).onClick) === null || _b === void 0 ? void 0 : _b.call(_a, e);
            if (!e.defaultPrevented) {
                void handleButtonClick(index, childNode.props.value);
            }
        };
        return cloneElement(childNode, Object.assign(Object.assign({}, childNode.props), { variant: (_a = childNode.props.variant) !== null && _a !== void 0 ? _a : variant, size: (_b = childNode.props.size) !== null && _b !== void 0 ? _b : size, isGrouped: true, groupPosition: position, isActive, onClick: handleClick, className: `${(_c = childNode.props.className) !== null && _c !== void 0 ? _c : ""} ${fullWidth ? "flex-1" : ""}` }));
    };
    return (_jsx("div", { className: `inline-flex ${fullWidth ? "w-full" : ""} ${className}`, children: Children.map(children, renderButton) }));
};
export default ButtonGroupV2;
